const BASE_URL = "https://volunteerconnect.pythonanywhere.com";
// const BASE_URL = "http://localhost:8000";

export default BASE_URL;
